
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".988","d":"m1.5 1.5 10.15 2.45L12.7 9.2l-3.5 3.5-5.25-1.05zm0 0 5.31 5.31M8.5 13.4l4.9-4.9 2.1 2.1-4.9 4.9zm.7-5.6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0"}})])
          )
        }
      }
    